import { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen } from 'features/ui/model/uiSlice';
import CloseIcon from '@mui/icons-material/Close';
import { Drawer, Typography, IconButton, TextField, MenuItem, Button, Box, Select, Tab } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { Controller, useForm } from 'react-hook-form';
import { TabContext, TabList } from '@mui/lab';
import { useGetCategoryQuery, useGetPartnersQuery } from 'widgets/product/ui/api/getShopsApi';
import { useGetCitiesQuery } from 'features/getCities/api/getCitiesApi';
import { toast } from 'react-toastify';
import { useGetCountriesQuery } from 'features/getCountries/api/getCountriesApi';
import { useCreateImageMutation } from 'widgets/product/ui/api/productImageApi';
import { useCreateProductMutation } from 'widgets/product/ui/api/shopCreateApi';

type FormDataType = {
  city_scope: any[];
  category_id: number;
  partner_id: number;
  product_type: string;
  language: string;
  contents: any[];
  available_products: any[];
  price: number;
  price2: number;
  price3: number;
};

type TabPanelPropsType = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

export const DrawerProduct = () => {
  const dispatch = useAppDispatch();
  const { isDrawerOpen } = useAppSelector((state) => state.ui);

  const { data: countryList } = useGetCountriesQuery(null);
  const { data: categoryList } = useGetCategoryQuery({
    per_page: 100,
    page: 1,
    order: 1,
  });
  const { data: productList } = useGetPartnersQuery({
    per_page: 100,
    page: 1,
    order: 1,
  });
  const { data: cityList } = useGetCitiesQuery({});
  const [createImageRequest] = useCreateImageMutation();
  const [createProductRequest] = useCreateProductMutation();

  const {
    getValues,
    control,
    formState: { errors: formErrors },
  } = useForm<FormDataType>({
    defaultValues: {
      contents: [
        {
          language_id: 1,
          title: '',
          description: '',
          image: '',
        },
        {
          language_id: 2,
          title: '',
          description: '',
          image: '',
        },
        {
          language_id: 3,
          title: '',
          description: '',
          image: '',
        },
        {
          language_id: 4,
          title: '',
          description: '',
          image: '',
        },
        {
          language_id: 5,
          title: '',
          description: '',
          image: '',
        },
      ],
    },
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const handleChange = (event: any) => {
    setFileName(event.target.files[0].name);
    setSelectedFile(event.target.files[0]);
  };
  const handleUploadClick = async (index: number) => {
    if (!selectedFile) {
      return;
    }
    const formData = new FormData();
    formData.append('image', selectedFile);

    createImageRequest(formData)
      .then((response) => {
        if ('error' in response) {
          toast.error('Произошла ошибка при сохранении файла', {
            position: toast.POSITION.TOP_RIGHT,
          });
          return;
        }

        if ('data' in response && response.data.image_reference != null) {
          const data2 = getValues();
          data2.contents[index].image = response.data.image_reference;
          toast.success('Файл успешно сохранен', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch(() => {
        toast.error('Произошла ошибка при сохранении файла', {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };
  const localCityList = { items: [] as any };

  const handleChangeCountry = (event: { target: { value: any } }) => {
    const {
      target: { value },
    } = event;

    setCountry(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  const handleChangeCity = (event: { target: { value: any } }) => {
    const {
      target: { value },
    } = event;

    setCities(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };
  const [country, setCountry] = useState([]);
  const [cities, setCities] = useState([]);

  cityList?.map((item) => {
    country.map((c) => {
      if (item.country_id === c) {
        localCityList.items.push({ name: item.name, id: item.id });
      }
    });
  });

  const city_scope = [] as any;

  const handleCreateProduct = async () => {
    const data = getValues();

    cities.map((item) => {
      city_scope.push({
        title: item,
      });
    });

    const payload = {
      category_id: data.category_id,
      partner_id: data.partner_id,
      sku: '',
      localizations: [
        {
          language: 'RU',
          title: data.contents[0].title,
          description: data.contents[0].description,
          image: data.contents[0].image,
        },
        {
          language: 'KZ',
          title: data.contents[1].title,
          description: data.contents[1].description,
          image: data.contents[1].image,
        },
        {
          language: 'EN',
          title: data.contents[2].title,
          description: data.contents[2].description,
          image: data.contents[2].image,
        },
        {
          language: 'KG',
          title: data.contents[3].title,
          description: data.contents[3].description,
          image: data.contents[3].image,
        },
        {
          language: 'UZ',
          title: data.contents[4].title,
          description: data.contents[4].description,
          image: data.contents[4].image,
        },
      ],
      city_scope,
      available_products: [
        {
          country: 'Казахстан',
          price: parseFloat(data.price.toString()),
          currency: 'KZT',
        },
        {
          country: 'Кыргызстан',
          price: parseFloat(data.price2.toString()),
          currency: 'KGS',
        },
        {
          country: 'Узбекстан',
          price: parseFloat(data.price3.toString()),
          currency: 'UZS',
        },
      ],
      product_promo_type: 'Промо',
      product_type: 'Физический',
      product_scope: [
        {
          title: 'B2B',
        },
      ],
    };

    createProductRequest(payload);
  };

  const [tabValue, setTabValue] = useState('0');
  const handleChangeTabValue = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [initState] = useState({
    directions: [],
    b2b_directions: [],
    b2b_tiers: [],
    countries: '',
    cities: '',
    contents: [
      {
        language: 1,
        title: '',
        description: '',
        image: '',
      },
      {
        language: 2,
        title: '',
        description: '',
        image: '',
      },
      {
        language: 3,
        title: '',
        description: '',
        image: '',
      },
      {
        language: 4,
        title: '',
        description: '',
        image: '',
      },
      {
        language: 5,
        title: '',
        description: '',
        image: '',
      },
    ],
    priority: 0,
  });

  const TabPanel = (props: TabPanelPropsType) => {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ marginTop: '16px' }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  const mystyle = {
    color: 'transparent',
  };

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => dispatch(setDrawerOpen(false))}
    >
      <DrawerContent>
        <div className="header">
          <Typography
            variant="h5"
            sx={{ fontWeight: '600' }}
          >
            Новый товар
          </Typography>
          <IconButton
            onClick={() => dispatch(setDrawerOpen(false))}
            sx={{ color: '#000' }}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <div className="content">
          <div>
            <Controller
              control={control}
              name="language"
              render={() => (
                <Box sx={{ width: '100%' }}>
                  <TabContext value={tabValue}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList
                        onChange={handleChangeTabValue}
                        aria-label="basic tabs example"
                      >
                        <Tab
                          value="0"
                          label="RU"
                          {...a11yProps(0)}
                        />
                        <Tab
                          value="1"
                          label="KK"
                          {...a11yProps(1)}
                        />
                        <Tab
                          value="2"
                          label="EN"
                          {...a11yProps(2)}
                        />
                        <Tab
                          value="3"
                          label="KG"
                          {...a11yProps(3)}
                        />
                        <Tab
                          value="4"
                          label="UZ"
                          {...a11yProps(4)}
                        />
                      </TabList>
                    </Box>
                    {initState.contents.map((item, index) => (
                      <TabPanel
                        value={+tabValue}
                        index={index}
                      >
                        <Controller
                          control={control}
                          name={`contents.${index}.title`}
                          render={({ field }) => (
                            <TextField
                              value={field.value}
                              onChange={(e) => field.onChange(e)}
                              label="Название товара"
                              size="small"
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              sx={{
                                marginBottom: '24px',
                              }}
                            />
                          )}
                        />
                        <Controller
                          control={control}
                          name={`contents.${index}.description`}
                          render={({ field }) => (
                            <TextField
                              value={field.value}
                              onChange={(e) => field.onChange(e)}
                              multiline
                              rows={4}
                              label="Описание товара"
                              size="small"
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              sx={{
                                marginBottom: '24px',
                              }}
                            />
                          )}
                        />
                        <Controller
                          control={control}
                          name={`contents.${index}.image`}
                          render={() => (
                            <input
                              type="file"
                              style={mystyle}
                              onChange={handleChange}
                            />
                          )}
                        />

                        <Button
                          onClick={() => {
                            handleUploadClick(index);
                          }}
                        >
                          Сохранить файл
                        </Button>
                        {fileName ? <div>{fileName}</div> : ''}
                      </TabPanel>
                    ))}
                  </TabContext>
                </Box>
              )}
            />
          </div>
          <br />
          <div>
            <Box sx={{ width: '100%' }}>
              <Typography>Детали товара</Typography>
              <div style={{ margin: '16px 0 16px 0' }} />
              <Controller
                name="category_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    select
                    type="text"
                    label="Категория"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    error={formErrors.language && true}
                    {...field}
                  >
                    {categoryList?.map((cat) => (
                      <MenuItem value={cat.product_category_id}>{cat.title_ru}</MenuItem>
                    ))}
                  </TextField>
                )}
              />

              <Controller
                name="partner_id"
                control={control}
                render={({ field }) => (
                  <TextField
                    select
                    type="text"
                    label="Партнёр"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    error={formErrors.language && true}
                    {...field}
                  >
                    {productList?.map((prod) => (
                      <MenuItem value={prod.partner_id}>{prod.description_ru}</MenuItem>
                    ))}
                  </TextField>
                )}
              />
              <div>Страна</div>
              <Select
                multiple
                type="number"
                value={country}
                onChange={handleChangeCountry}
                placeholder=""
                fullWidth
                size="small"
                sx={{
                  marginBottom: '24px',
                }}
              >
                {countryList ? (
                  countryList.map((item) => (
                    <MenuItem
                      value={item.id}
                      key={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>loading</MenuItem>
                )}
              </Select>

              <div>Город</div>
              <Select
                multiple
                type="number"
                value={cities}
                onChange={handleChangeCity}
                placeholder=""
                fullWidth
                size="small"
                sx={{
                  marginBottom: '24px',
                }}
              >
                {localCityList ? (
                  localCityList.items.map((item: any) => (
                    <MenuItem
                      value={item.name}
                      key={item.id}
                    >
                      {item.name}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem>loading</MenuItem>
                )}
              </Select>

              <Controller
                name="product_type"
                control={control}
                render={({ field }) => (
                  <TextField
                    select
                    type="text"
                    label="Товар доступен для направления"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    {...field}
                  >
                    <MenuItem
                      value={0}
                      key={0}
                    >
                      Физический
                    </MenuItem>
                    <MenuItem
                      value={1}
                      key={1}
                    >
                      Виртуальный
                    </MenuItem>
                  </TextField>
                )}
              />

              <Controller
                name="price"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="number"
                    label="Казахстан: стоимость единицы товара"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    {...field}
                  />
                )}
              />
              <Controller
                name="price2"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="number"
                    label="Кыргызстан: стоимость единицы товара"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    {...field}
                  />
                )}
              />

              <Controller
                name="price3"
                control={control}
                render={({ field }) => (
                  <TextField
                    type="number"
                    label="Узбекистан: стоимость единицы товара"
                    placeholder=""
                    fullWidth
                    size="small"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    sx={{
                      marginBottom: '24px',
                    }}
                    {...field}
                  />
                )}
              />
            </Box>
          </div>

          <Box
            sx={{
              display: 'flex',
              marginTop: '30px',
            }}
          >
            <Button
              variant="contained"
              sx={{ textTransform: 'none' }}
              onClick={handleCreateProduct}
            >
              Создать
            </Button>
          </Box>
        </div>
      </DrawerContent>
    </Drawer>
  );
};
